import { RootState } from '../../../../stores/store';

export const insectListSelector = (state: RootState) => state.listOfInsect;
